function Spackling() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 500 500"
      width="100%"
      height="100%"
    >
      <g
        fill="none"
        stroke="#CF9857"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <path
          d="M 33.7,460.5 C 25.1,466.5 15.2,460.7 20.4,450.4 L 165.7,272.7 C 170.8,266.4 179.7,264.4 186.9,268.0 L 360.2,389.2 C 367.6,394.4 366.5,404.7 357.7,407.7 L 38.6,460.2 Z"
          stroke-width="12"
        />

        <path d="M 27.2,456.2 L 217.4,357.0" stroke-width="8" />

        <path
          d="M 255.4,337.5 C 217.1,357.5 218.4,337.0 236.8,323.0 C 257.6,307.2 268.7,280.9 254.8,242.0 L 260.6,220.3 C 265.4,209.6 274.9,215.1 282.8,222.0"
          stroke-width="12"
        />
        <path
          d="M 233.1,349.0 C 206.8,362.8 205.7,344.4 224.1,330.4 C 244.9,314.6 256.0,288.3 242.1,249.4 L 247.9,227.7"
          stroke-width="8"
        />

        <ellipse
          cx="282.6"
          cy="221.4"
          rx="14.5"
          ry="11.2"
          transform="rotate(-30 282.6 221.4)"
          stroke-width="10"
        />

        <path
          d="M 292.0,214.5 C 304.8,175.7 348.8,127.6 426.1,46.9 C 454.4,18.7 483.5,37.8 477.8,70.5 C 470.7,111.4 411.7,185.0 327.9,236.2 C 308.2,248.2 291.5,236.8 292.0,214.5 Z"
          stroke-width="12"
        />

        <text
          x="415"
          y="142"
          fill="#CF9857"
          stroke="none"
          font-family="Arial, sans-serif"
          font-size="16"
          font-weight="900"
          letter-spacing="1"
          transform="rotate(-40 415 142)"
        ></text>
      </g>
    </svg>
  );
}

export default Spackling;
